import classNames from 'classnames/bind';
import { useEffect, useRef, useState } from 'react';
import { Dropdown, Modal } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpShortWide } from '@fortawesome/pro-regular-svg-icons/faArrowUpShortWide';
import { faArrowDownShortWide } from '@fortawesome/pro-regular-svg-icons/faArrowDownShortWide';
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';

import windowWidthDecorator from '../../../../../decorators/windowWidthDecorator';
import withComponentName from '../../../../../decorators/withComponentName';

import StorageSvc from '../../../../../services/StorageSvc';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const DropdownSortingFilter = ({
  windowWidth: width,
  values: defaultValues,
  type,
  handleSorting,
}) => {
  const [dropdown, setDropdown] = useState({
    open: false,
    selected: { option: {}, scending: {} },
    options: [],
    scending: [],
  });
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [dropdownTitle, setDropdownTitle] = useState('');

  const prevDropdownTitleRef = useRef(null);

  const getState = (setState) => new Promise((resolve) => {
    setState((currentState) => {
      resolve(currentState);
      return currentState;
    });
  });

  const saveState = async (argument) => {
    let updatedState = null;
    if (argument === 'setValueSelected' || argument === 'setScendingSelected'
    || argument === 'setValues') updatedState = await getState(setDropdown);

    if (!updatedState) updatedState = dropdown;

    StorageSvc.setItem(
      `${type}Filter`,
      JSON.stringify({ dropdown: { ...updatedState, open: false } }),
    );
    setDropdownTitle(updatedState.selected.option?.name);
    handleSorting({
      method: updatedState.selected.option.value,
      scending: updatedState.selected.scending?.value,
    });
  };

  const handleOpenFilterModal = () => {
    setOpenFilterModal((prevState) => !prevState);
  };

  const toggleDropdown = () => {
    if (width <= 1024) return handleOpenFilterModal();

    setDropdown((prevState) => ({ ...prevState, open: !prevState.open }));
  };

  const setValueSelected = (selectedItem) => {
    setDropdown((prevState) => ({
      ...prevState,
      selected: { ...prevState.selected, option: selectedItem },
    }));

    saveState('setValueSelected');
  };

  const setScendingSelected = (selectedItem) => {
    setDropdown((prevState) => ({
      ...prevState,
      selected: { ...prevState.selected, scending: selectedItem },
    }));

    saveState('setScendingSelected');
  };

  const handleCloseModal = () => {
    setOpenFilterModal(false);
  };

  const setValues = (arg) => {
    const { options: values, scending } = arg;

    if (!dropdown.selected.option?.value || !dropdown.selected.scending?.value) {
      const defaultValue = values.filter((item) => item.value === 'created');
      const defaultScending = scending.filter((item) => item.value === 'ascending');

      if (!dropdown.selected.option?.value && !dropdown.selected.scending?.value) {
        setDropdown((prevState) => ({
          ...prevState,
          options: values,
          open: false,
          selected: { option: defaultValue[0], scending: defaultScending[0] },
          scending,
        }));
        return;
      } if (!dropdown.selected.option?.value) {
        setDropdown((prevState) => ({
          ...prevState,
          options: values,
          open: false,
          selected: { ...prevState.selected, option: defaultValue[0] },
          scending,
        }));
        return;
      } if (!dropdown.selected.scending?.value) {
        setDropdown((prevState) => ({
          ...prevState,
          options: values,
          open: false,
          selected: { ...prevState.selected, scending: defaultScending[0] },
          scending,
        }));
        return;
      }
    } else {
      setDropdown((prevState) => ({
        ...prevState,
        open: false,
        options: values,
        scending,
      }));
    }
    saveState('setValues');
  };

  useEffect(() => {
    const presisted = StorageSvc.getItem(`${type}Filter`);

    if (presisted !== null) {
      const rehydrate = JSON.parse(presisted);

      rehydrate.dropdown.options = defaultValues.options;

      if (type === 'sortingWatchlistsFilter' && !defaultValues.options.some(({ value }) => value === rehydrate.dropdown.selected.value)) {
        [rehydrate.dropdown.selected] = defaultValues.options;
      }

      setDropdown((prevState) => ({ ...prevState, ...rehydrate.dropdown }));
      handleSorting({
        method: rehydrate.dropdown.selected.option.value,
        scending: rehydrate.dropdown.selected.scending.value,
      });
    } else {
      setValues(
        defaultValues,
      );
    }
    setDropdownTitle(dropdown.selected.option?.name);
  }, []);

  useEffect(() => {
    prevDropdownTitleRef.current = dropdownTitle;
    if (prevDropdownTitleRef.current !== dropdown.selected.option?.name) {
      setDropdownTitle(dropdown.selected.option?.name);
    }
  }, [dropdown]);

  return (
    <Dropdown
      bsPrefix={cx('')}
      onToggle={(status, event, source) => toggleDropdown(status, event, source)}
      show={dropdown.open}
      className={cx('sorting-wl')}
    >
      <Dropdown.Toggle
        id={cx(`${type}-dropdown`)}
        variant="default"
      >
        <FilterButtonInfo
          dropdownTitle={dropdownTitle}
          openFilter={dropdown.open}
          width={width}
          selectedValue={dropdown.selected.option?.name}
          scending={dropdown.selected.scending}
        />
      </Dropdown.Toggle>
      {width >= 1025 ? (
        <Dropdown.Menu
          rootCloseEvent="click"
          show={dropdown.open}
          flip={false}
          bsPrefix="dropdown-menu"
        >
          <FilterInner
            dropdown={dropdown}
            dropdownTitle={dropdownTitle}
            setValueSelected={setValueSelected}
            setScendingSelected={setScendingSelected}
            type={type}
            handleCloseModal={handleCloseModal}
          />
        </Dropdown.Menu>
      ) : (
        <FiltersMobileModal
          openFilter={openFilterModal}
          handleCloseModal={handleCloseModal}
          showCloseIcon
        >
          <FilterInner
            dropdown={dropdown}
            dropdownTitle={dropdownTitle}
            setValueSelected={setValueSelected}
            setScendingSelected={setScendingSelected}
            type={type}
            handleCloseModal={handleCloseModal}
          />
        </FiltersMobileModal>
      )}
    </Dropdown>
  );
};

const FilterInner = ({
  dropdown,
  setValueSelected,
  setScendingSelected,
  handleCloseModal,
}) => (
  <div
    className={cx('dropdown-items-wrapper', 'full-width-dropdown')}
  >
    <div className={cx('dropdown-header')}>
      <span>SORT BY</span>
      <FontAwesomeIcon
        onClick={(e) => {
          if (handleCloseModal) {
            handleCloseModal(e);
          }
        }}
        icon={faTimes}
      />
    </div>
    {dropdown.options.map((item, index) => (
      <Dropdown.Item
        key={item.name}
        eventKey={index}
        active={dropdown.selected.option?.value === item.value}
        onSelect={() => setValueSelected(item)}
        className={cx({ 'last-child': index === (dropdown.options.length - 1) })}
      >
        {item.name}
      </Dropdown.Item>
    ))}
    <span className={cx('sort-direction')}>Sorting order:</span>
    {dropdown.scending.map((item, index) => (
      <Dropdown.Item
        key={item.name}
        eventKey={index}
        active={dropdown.selected.scending?.value === item.value}
        onSelect={() => setScendingSelected(item)}
      >
        {item.name}
      </Dropdown.Item>
    ))}
  </div>
);

const FilterButtonInfo = ({
  dropdownTitle,
  scending,
  hideLabel,
}) => (
  <>
    <div
      className={cx(
        'dropdown-icon',
        { 'show-always': hideLabel },
      )}
    >
      <FontAwesomeIcon
        icon={scending.value === 'ascending' ? faArrowUpShortWide : faArrowDownShortWide}
      />
    </div>
    <p className={cx('story-filters__btn--title', 'mob')}>{dropdownTitle}</p>
  </>
);

const FiltersMobileModal = ({
  openFilter, handleCloseModal, children, classname,
}) => {
  const handleClick = (e) => {
    if (handleCloseModal) {
      handleCloseModal(e);
    }
  };

  return (
    <Modal
      show={openFilter}
      onHide={handleClick}
      className={cx('sorting-wl-mobile-modal', classname && classname)}
      centered
    >
      {children}
    </Modal>
  );
};

export default withComponentName(windowWidthDecorator(DropdownSortingFilter));
